<template>
  <div class="">
    <div class="auto_1280">
      <div class="agriculture" v-html="content"></div>
    </div>
    <div class="part2" v-if="isShow">
      <div class="auto_1280">
        <div class="tit" v-if="detail.tag !== 'true'">{{detail.tag}}</div>
        <ul class="ul clearfix">
          <li v-for="( item, index ) in list" :key="index" @click="goDetail(item.id)" class="clearfix">
            <div class="box">
              <div class="pic bg_cover"  :style="'background-image: url(' + item.coverImg + ')'">
                <div class="cover" v-if="item.isUpload === 1"><span class="icon"></span></div>
              </div>
              <div class="content">
                <div class="title1 dot">{{item.title}}</div>
                <div class="txt1 dot2">{{item.intro}}</div>
              </div>
            </div>
          </li>
        </ul>
        <div class="pager" v-if="list.length > 0">
          <span class="p_page">
            <a @click="pageIndex = ( pageIndex == 1 ? 1 : pageIndex - 1 );" class="a_prev" :class="{disable_prev: pageIndex == 1}"></a>
            <em class="num">
              <template v-for="( num, index ) in pageList">
                <a @click="pageIndex = num;" :key="index" :class="[ num == pageIndex ? 'a_cur' : '' ]">{{num}}</a>
              </template>
            </em>
            <a @click="pageIndex = ( pageIndex == maxPageIndex ? maxPageIndex : pageIndex + 1 );" class="a_next" :class="{disable_next: pageIndex == maxPageIndex}"></a>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Agriculture',
  data () {
    return {
      content: '',
      articleTypeId: 11,
      lan: this.$store.state.isEn,
      pageList: [],
      pageIndex: 1,
      pageSize: 6,
      total: 0,
      maxPageIndex: 1,
      list: [],
      isShow: false,
      detail: {}
    }
  },
  watch: {
    pageIndex (val, oldval) {
      if (val !== oldval) {
        this.initList()
      }
    },
    '$store.state.isEn' () {
      this.lan = this.$store.state.isEn
      this.init()
      this.initList()
    }
  },
  mounted () {
    localStorage.removeItem('path')
    localStorage.removeItem('columnId')
    const self = this
    self.initId()
    self.init()
    self.initList()
  },
  activated () {
    this.initId()
  },
  methods: {
    initId () {
      const self = this
      // let menuList
      // try {
      //   menuList = JSON.parse(localStorage.getItem('routeList'))
      // } catch (e) {
      //   console.log(e)
      // }
      // const id = parseInt(self.$route.query.columnId)
      // const index = self.$route.path.lastIndexOf('/')
      // const path = self.$route.path.substring(index + 1, self.$route.path.length)
      // menuList.forEach((item) => {
      //   if (id === item.id) {
      //     item.children.forEach((inner) => {
      //       if (inner.requestTo.toLowerCase() === path) {
      //         self.articleTypeId = inner.id
      //         self.$store.commit('changeId', inner.id)
      //       }
      //     })
      //   }
      // })
      self.$store.commit('changeId', self.articleTypeId)
    },
    init () {
      const self = this
      self.list = []
      self.$api.post('api/benefitArticle/queryByParam', { articleTypeId: self.articleTypeId, current: 1, pageSize: 1, bLanguage: this.lan, tag: 'true' }, r => {
        if (r) {
          self.detail = r.data[0]
          let content = r.data[0].content.replace(/%/g, '%25')
          self.content = decodeURIComponent(content)
        }
      })
    },
    initList () {
      const self = this
      self.list = []
      self.$api.post('api/benefitArticle/queryByParam', { articleTypeId: self.articleTypeId, current: self.pageIndex, pageSize: self.pageSize, bLanguage: this.lan, video: 'true' }, r => {
        if (r.total && r.data) {
          self.total = r.total
          r.data.forEach((item) => {
            if (item.tag === '') {
              self.isShow = true
              self.list.push(item)
            }
          })
        }
        self.initPager()
      })
      self.$nextTick(function () {
        self.initEL()
      })
    },
    initEL () {},
    initPager () {
      const self = this
      const footerCount = 5
      self.pageList = []
      self.maxPageIndex = parseInt(self.total / self.pageSize) + (self.total % self.pageSize === 0 ? 0 : 1)
      let startPageIndex = self.pageIndex - parseInt(footerCount / 2)
      startPageIndex = startPageIndex < 1 ? 1 : startPageIndex
      for (let i = startPageIndex; i <= self.maxPageIndex; i++) {
        self.pageList.push(i)
        if (self.pageList.length >= footerCount) break
      }
    },
    goDetail (id) {
      const index = this.$route.path.lastIndexOf('/')
      // 用于从详情页跳回到列表页
      localStorage.setItem('path', this.$route.path.substring(index + 1, this.$route.path.length))
      localStorage.setItem('columnId', this.$route.query.columnId)
      this.$router.push({
        path: '/ruralvitalization/detail',
        query: {
          columnId: this.$route.query.columnId,
          articleTypeId: this.articleTypeId,
          id
        }
      })
    }
  }
}
</script>
<style>
.agriculture{padding: 2% 0 8%;}
.agriculture .text-fl,
.agriculture .pic-fl{float: left; width: 50%; box-sizing: border-box;}
.agriculture .text-fr,
.agriculture .pic-fr{float: right; width: 50%; box-sizing: border-box;}
.agriculture .text-fl{padding-right: 5%;}
.agriculture .text-fr{padding: 5% 4% 0 5%;}
.agriculture .text-fl,
.agriculture .text-fr{text-align: left!important;}
.agriculture .tit1{font-size: 30px; color: #333; line-height: 1.8;}
.agriculture .tit2{font-size: 20px; color: #333; line-height: 1.8;}
.agriculture .txt{font-size: 16px; color: #000; padding-top: 8%; line-height: 2;}
@media(max-width: 1024px){
  .agriculture .text-fl,
  .agriculture .pic-fl,
  .agriculture .text-fr,
  .agriculture .pic-fr{float: none; width: 100%;}
  .agriculture .text-fl{padding-right: 0;}
  .agriculture .text-fr{padding: 0;}
  .agriculture .txt{padding-top: 2%;}
  .agriculture .pic-fl,
  .agriculture .pic-fr{text-align: center; padding: 2% 0;}
  .agriculture .tit1{font-size: 26px!important;}
  .agriculture .tit2{font-size: 18px;}
  .agriculture img{width: 100%!important; height: auto!important;}
}
</style>
<style scoped>
.part2{background-color: #f8f8f8; overflow: hidden; padding-bottom: 5%; padding-top: 4%;}
.part2 .box{position: relative;}
.part2 .pic{float: right; width: 100%; padding-top: 65%; border-radius: 5px; position: relative;}
.part2 .pic .cover{position: absolute; opacity: 0; left: 0; top: 0; width: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,.4); transition: all .3s; display: flex; justify-content: center; align-items: center;}
.part2 .pic .icon{background: url(../../assets/play-icon.png)no-repeat center; width: 56px; height: 36px; display: inline-block; opacity: 1;}
.part2 li:hover .cover{opacity: 1;}
.part2 .content{float: left; width: 100%; position: relative; padding: 2% 0;}
.part2 ul{margin: 0 -2%;}
.part2 li{padding: 0 2%; margin-bottom: 2%; cursor: pointer; float: left; width: 33.33%;}
.part2 .title1{font-size: 20px; color: #333; transition: all .3s;}
.part2 .txt1{font-weight: lighter; line-height: 1.8; min-height: 56px; color: #666; margin: 1% 0 3% 0; word-break: break-word; transition: all .3s;}
.part2 li:hover .title1{color: #e4007f;}
.part2 li:hover .txt1{color: #e4007dc4;}
.part2 .tit{font-size: 30px; padding: 2% 0 3% 0;}
@media(max-width: 768px){
  .part2 .title1{font-size: 18px;}
}
@media(max-width: 640px){
  .part2 li{width: 100%;}
  .part2 .txt1{min-height: 0;}

  .part2 .pic .cover{opacity: 1;}
}
</style>
